/* unplugin-vue-components disabled */import script from "./EditorDrawerBackground.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorDrawerBackground.vue?vue&type=script&setup=true&lang=js"

import "./EditorDrawerBackground.vue?vue&type=style&index=0&id=2bc0b5b4&lang=scss"

const __exports__ = script;

export default __exports__